import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchAppIfNeeded, openApp} from '../actions/apps';
import initLNScroll from '../services/ln-scroll';
import {execBI, appEventStore} from '../services/bi-events-manager';
import AppPage from '../components/App-page';
import {navigateBack} from '../services/history';
import {AppMetadata} from '../components/Metadata';
import ALink from '../components/ALink';

const handleBack = (ev) => {
  ev.preventDefault();
  navigateBack(true);
};


class App extends React.Component {

  static fetchData(dispatch, params) {
    const appSlug = params.appSlug;
    dispatch(openApp(appSlug));
    return dispatch(fetchAppIfNeeded(appSlug));
  }

  componentDidMount() {
    window.document.body.classList.add('overflow-hidden');

    if (this.props.isModal && this.props.data.appDefinitionId) {
      initLNScroll(window.document.querySelector('.tab-content .tab-pane'));
      execBI('APP_PAGE_OPENED', {app: this.props.data, biPosition: appEventStore.lastAppClickedPosition});
    }
  }

  componentWillUnmount() {
    this.props.dispatch(openApp(null));
    window.document.body.classList.remove('overflow-hidden');
  }

  closeFixedPopup(ev) {
    if (ev.target === this.popup) {
      navigateBack(true);
    }
  }

  render() {
    const app = this.props.data;
    const reviews = this.props.reviews[app.appDefinitionId];
    const isError = !this.props.isFetching && !app.appDefinitionId;

    return (
      <div className="short-header-page">
        <div className="app-page-container" onClick={(ev) => this.closeFixedPopup(ev)} ref={(i) => this.popup = i}>

          {!this.props.isModal ? <div onClick={handleBack} className="app-page-overlay"></div> : null}

          {!this.props.isModal ?
            <ALink onClick={handleBack} to={'/'} className="app-page-close" title="Back"></ALink> : null}

          <AppPage app={app} reviews={reviews} tabUrl={this.props.tabUrl} isModal={this.props.isModal} isError={isError}/>

        </div>
        <AppMetadata title={app.name} description={app.teaser} id={app.appDefinitionId}/>
      </div>
    );
  }

  static propTypes = {
    params: PropTypes.object,
    dispatch: PropTypes.func,
    data: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    tabUrl: PropTypes.string,
    reviews: PropTypes.object,
    isModal: PropTypes.bool
  };
}

function mapStateToProps(state, props) {
  const appSlug = props.params.appSlug;
  const {data, isFetching} = state.apps.list[appSlug] || {data: {}, isFetching: true};
  return {
    data,
    isFetching,
    reviews: state.reviews.all,
    tabUrl: props.route.isModal ? props.params.tabUrl : props.route.tabUrl,
    isModal: props.route.isModal
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./containers/App.js